import {
  initialState,
  Actions,
  State,
  GET_ONE_RESPONSIBLE,
  GET_ONE_RESPONSIBLE_SUCCESS,
  GET_ONE_RESPONSIBLE_ERROR,
  RESET_GET_ONE_RESPONSIBLE,
} from '../../types/responsible/get-one'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_RESPONSIBLE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ONE_RESPONSIBLE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ONE_RESPONSIBLE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ONE_RESPONSIBLE:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
